import ProjectList from '@/components/projects/ProjectList';
import PathwayNavigator from '@/components/home/PathwayNavigator';
import { Link, Outlet } from 'react-router';
import { PlusIcon } from '@heroicons/react/24/outline';
import PageTitle from '@/components/core/PageTitle';
import Changelog from '@/components/changelog/Changelog';
import HowTos from '@/components/home/HowTos';
import featureConfig from '@/featureConfig';
import { useIsFeatureEnabled } from '@/stores/settingsStore';

const NewProjectLink = () => (
  <Link to="/projects/new" className="btn btn-accent btn-sm">
    <PlusIcon className="h-5 w-5 fill-gray-100" />
    New Project
  </Link>
);

const AnalystCard = () => (
  <Link
    to="/analyst"
    className="block bg-white rounded-lg shadow-sm border px-4 py-3 hover:border-slate-300 transition-colors group"
  >
    <div className="font-semibold text-sm text-slate-800 mb-0.5">Sesame Analyst</div>
    <div className="text-xs text-slate-400 leading-relaxed">
      Energy project costs, emissions, and technology comparisons.
    </div>
    <span className="text-xs text-slate-400 group-hover:text-slate-600 transition-colors mt-1.5 inline-block">
      Open →
    </span>
  </Link>
);

const ProjectsRoute = () => {
  const isAnalystEnabled = useIsFeatureEnabled('agent_analyst');
  const rightSidebarEnabled =
    isAnalystEnabled || featureConfig.enablePathwayNavigator || featureConfig.enableChangelog || featureConfig.enableHowTos;

  return (
    <div className="flex flex-col bg-gray-50 shadow-lg shadow-slate-200 rounded-t-lg h-full size-11/12 overflow-hidden">
      <PageTitle className="bg-primary text-primary-content" />
      <div className="overflow-y-scroll p-6">
        <div className="flex flex-col flex-grow gap-6">
          <div className="flex gap-6 min-h-[60vh]">
            <div className="w-[65%] bg-white rounded-lg shadow-sm border">
              <div className="p-4">
                <div className="border-b flex justify-between pb-3">
                  <div className="font-bold text-lg">Projects</div>
                  {featureConfig.manageProjects && <NewProjectLink />}
                </div>
              </div>
              <div className="flex-1 overflow-y-auto px-4 pb-4">
                <ProjectList />
              </div>
            </div>
            {rightSidebarEnabled && (
              <div className="w-[35%] flex flex-col gap-4">
                {isAnalystEnabled && <AnalystCard />}
                {featureConfig.enablePathwayNavigator && <PathwayNavigator />}
                {featureConfig.enableChangelog && <Changelog />}
                {featureConfig.enableHowTos && <HowTos />}
              </div>
            )}
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ProjectsRoute;
